import { Reveal } from "./Reveal";

const chapters = [
  {
    num: "01",
    title: "Lake Eufaula Serenity",
    body: "Forty-five thousand acres of the South's finest fishing lake sit just minutes from your room — charters, marinas and sunset cruises within easy reach whenever the water calls.",
  },
  {
    num: "02",
    title: "Southern Architectural Grandeur",
    body: "Eufaula holds one of Alabama's largest historic districts — more than 700 antebellum and Victorian structures. The Shorter Mansion and mansion row are a short stroll from our door.",
  },
  {
    num: "03",
    title: "Tailored Hospitality",
    body: "No call centers, no booking fees. When you phone us, you speak with someone who knows the lake, the town and your room. That is how the South has always done it.",
  },
];

export const Chapters = () => (
  <section className="bg-[#F8F6F0] py-20 md:py-28" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-[#C5A059] mb-14">The Haven Manifesto</p>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-10 lg:gap-16">
        {chapters.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.12}>
            <div className="border-t border-[#0D1B2A]/15 pt-8 group" data-testid={`chapter-${c.num}`}>
              <span className="font-serif-display text-6xl lg:text-7xl font-bold text-[#C5A059]/35 group-hover:text-[#C5A059] transition-colors duration-500">
                {c.num}
              </span>
              <h3 className="font-serif-display text-2xl lg:text-3xl font-semibold text-[#0A192F] mt-4">{c.title}</h3>
              <p className="mt-4 text-[#4A5568] leading-relaxed text-sm sm:text-base">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
